/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMessageLanguage = createReactComponent("message-language", "IconMessageLanguage", [
  [
    "path",
    {
      d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4",
      key: "svg-0"
    }
  ],
  ["path", { d: "M10 14v-4a2 2 0 1 1 4 0v4", key: "svg-1" }],
  ["path", { d: "M14 12h-4", key: "svg-2" }]
]);

export { IconMessageLanguage as default };
//# sourceMappingURL=IconMessageLanguage.js.map
